import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import "./DatePicker.css";
import './first_page/landing.css';

import Navbar from './first_page/src/components/Navbar';
import Hero from './first_page/src/components/Hero';
import InfoCards from './first_page/src/components/InfoCards';
import About from './first_page/src/components/About';
import LandingFooter from './first_page/src/components/Footer';

import AsideLeft2 from "./component/AsideLeft2.js";
import TitleBar from "./component/TitleBar.js";
import Footer from "./component/Footer.js";

import ArticleTable from "./component/ArticleTable.js";
import ArticleGraph from "./component/ArticleGraph";
import CalendarParentArticle from "./component/CalendarParentArticle";
import CalendarParentLocation from "./component/CalendarParentLocation";
import Mapping from "./component/Mapping";
import MainSection from "./component/MainSection";

import ArticleTablePinus from "./component/ArticleTablePinus";
import ArticleGraphPinus from "./component/ArticleGraphPinus";
import CalendarParentArticlePinus from "./component/CalendarParentArticlePinus";
import CalendarParentLocationPinus from "./component/CalendarParentLocationPinus";
import MappingPinus from "./component/MappingPinus";
import MainSectionPinus from "./component/MainSectionPinus";

import ArticleTableRice from "./component/ArticleTableRice";
import ArticleGraphRice from "./component/ArticleGraphRice";
import CalendarParentArticleRice from "./component/CalendarParentArticleRice";
import CalendarParentLocationRice from "./component/CalendarParentLocationRice";
import MappingRice from "./component/MappingRice";
import MainSectionRice from "./component/MainSectionRice";

/** 공통 레이아웃: AsideLeft2 + TitleBar + Footer 포함 */
function PageLayout({ title, selectedDisease, onDiseaseChange, children }) {
  return (
    <>
      <AsideLeft2 selectedDisease={selectedDisease} onDiseaseChange={onDiseaseChange} />
      <TitleBar name={title} />
      <section className="section main-section">
        {children}
      </section>
      <Footer />
    </>
  );
}
/** 초기화면 */
function FirstPage() {
  useEffect(() => {
    document.body.classList.add('first-page-body');

    return () => {
      document.body.classList.remove('first-page-body');
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col first-page">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <InfoCards />
        <About />
      </main>
      <LandingFooter />
    </div>
  )
}

/** 과수화상병 */
function FireblightHome({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="과수화상병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSection />
      <div className="card mb-6">
        <Mapping />
        <ArticleTable />
      </div>
    </PageLayout>
  );
}

function FblightMap({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="과수화상병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSection />
      <div className="card mb-6">
        <CalendarParentLocation />
      </div>
    </PageLayout>
  );
}

function FblightTable({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="과수화상병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSection />
      <div className="card mb-6">
        <CalendarParentArticle />
      </div>
    </PageLayout>
  );
}

function FblightGraph({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="과수화상병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSection />
      <ArticleGraph />
    </PageLayout>
  );
}

/** 도열병 */
function RblastHome({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="벼 도열병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSectionRice />
      <div className="card mb-6">
        <MappingRice />
        <ArticleTableRice />
      </div>
    </PageLayout>
  );
}

function RblastMap({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="벼 도열병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSectionRice />
      <div className="card mb-6">
        <CalendarParentLocationRice />
      </div>
    </PageLayout>
  );
}

function RblastTable({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="벼 도열병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSectionRice />
      <div className="card mb-6">
        <CalendarParentArticleRice />
      </div>
    </PageLayout>
  );
}

function RblastGraph({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="벼 도열병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSectionRice />
      <ArticleGraphRice />
    </PageLayout>
  );
}

/** 소나무재선충병 */
function PwiltHome({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="소나무재선충병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSectionPinus />
      <div className="card mb-6">
        <MappingPinus />
        <ArticleTablePinus />
      </div>
    </PageLayout>
  );
}

function PwiltMap({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="소나무재선충병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSectionPinus />
      <div className="card mb-6">
        <CalendarParentLocationPinus />
      </div>
    </PageLayout>
  );
}

function PwiltTable({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="소나무재선충병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSectionPinus />
      <div className="card mb-6">
        <CalendarParentArticlePinus />
      </div>
    </PageLayout>
  );
}

function PwiltGraph({ selectedDisease, onDiseaseChange }) {
  return (
    <PageLayout
      title="소나무재선충병"
      selectedDisease={selectedDisease}
      onDiseaseChange={onDiseaseChange}
    >
      <MainSectionPinus />
      <ArticleGraphPinus />
    </PageLayout>
  );
}

function App() {
  // ✅ 상태는 App 최상단에서 딱 1번만 관리
  const [selectedDisease, setSelectedDisease] = useState('fireblight');

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<FirstPage />}
        />

        <Route
          path="/fblight"
          element={<FireblightHome selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />
        <Route
          path="/fblightmap"
          element={<FblightMap selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />
        <Route
          path="/fblighttable"
          element={<FblightTable selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />
        <Route
          path="/fblightgraph"
          element={<FblightGraph selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />

        <Route
          path="/rblast"
          element={<RblastHome selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />
        <Route
          path="/rblastmap"
          element={<RblastMap selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />
        <Route
          path="/rblasttable"
          element={<RblastTable selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />
        <Route
          path="/rblastgraph"
          element={<RblastGraph selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />

        <Route
          path="/pwilt"
          element={<PwiltHome selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />
        <Route
          path="/pwiltmap"
          element={<PwiltMap selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />
        <Route
          path="/pwilttable"
          element={<PwiltTable selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />
        <Route
          path="/pwiltgraph"
          element={<PwiltGraph selectedDisease={selectedDisease} onDiseaseChange={setSelectedDisease} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
